// import React, { useState } from "react";
// import Card from "components/card";
// import { MdClose } from "react-icons/md";
// import { FaTrain } from "react-icons/fa";

// const RailwayModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     route: "",
//     time: "",
//     price: "",
//     travelDate: ""
//   });

//   React.useEffect(() => {
//     if (editingItem) {
//       setFormData({
//         name: editingItem.name || "",
//         route: editingItem.route || "",
//         time: editingItem.time || "",
//         price: editingItem.price || "",
//         travelDate: editingItem.travelDate || ""
//       });
//     } else {
//       setFormData({ name: "", route: "", time: "", price: "", travelDate: "" });
//     }
//   }, [editingItem, isOpen]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onAdd(formData);
//     setFormData({ name: "", route: "", time: "", price: "", travelDate: "" });
//     onClose();
    
//     // Trigger auto-save by dispatching custom event
//     setTimeout(() => {
//       window.dispatchEvent(new CustomEvent('cartesUpdated'));
//     }, 600);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//       <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
//         <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6 rounded-t-[20px]">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-3">
//               <div className="rounded-full bg-white p-2">
//                 <FaTrain className="h-6 w-6 text-purple-500" />
//               </div>
//               <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Train Details' : 'Add Train Details'}</h3>
//             </div>
//             <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
//               <MdClose className="h-6 w-6" />
//             </button>
//           </div>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
         
//           <div>
//             <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Route</label>
//             <input
//               type="text"
//               placeholder="e.g., Central → North Station"
//               value={formData.route}
//               onChange={(e) => setFormData({...formData, route: e.target.value})}
//               className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//               required
//             />
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Travel Date</label>
//               <input
//                 type="date"
//                 value={formData.travelDate}
//                 onChange={(e) => setFormData({...formData, travelDate: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure & Arrival Time</label>
//               <input
//                 type="text"
//                 placeholder="e.g., 8:00 AM - 12:30 PM"
//                 value={formData.time}
//                 onChange={(e) => setFormData({...formData, time: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//           </div>
          
//           <div className="flex space-x-4 pt-4">
//             <button
//               type="submit"
//               className="flex-1 rounded-xl bg-gradient-to-r from-purple-500 to-purple-600 py-3 px-6 text-white font-semibold hover:from-purple-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
//             >
// {editingItem ? 'Update Train' : 'Add Train'}
//             </button>
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 rounded-xl bg-gray-100 py-3 px-6 text-gray-700 font-semibold hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </Card>
//     </div>
//   );
// };

// export default RailwayModal;

import React, { useState, useEffect } from "react";
import Card from "components/card";
import { MdClose } from "react-icons/md";
import { FaTrain } from "react-icons/fa";

// Dummy trains for demo
const dummyTrains = [
  { id: 1, name: "Express Line", route: "Central → North Station", time: "8:00 AM - 12:30 PM", price: "50" },
  { id: 2, name: "Rapid Rail", route: "Central → North Station", time: "10:00 AM - 2:30 PM", price: "60" },
  { id: 3, name: "City Connector", route: "Central → North Station", time: "1:00 PM - 5:30 PM", price: "55" },
];

const RailwayModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    route: "",
    travelDate: "",
    time: ""
  });
  const [availableTrains, setAvailableTrains] = useState([]);
  const [selectedTrain, setSelectedTrain] = useState(null);
  const [searching, setSearching] = useState(false);

  const getTodayDate = () => {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData({
        route: editingItem.route || "",
        travelDate: editingItem.travelDate || getTodayDate(),
        time: editingItem.time || ""
      });
      setSelectedTrain(editingItem);
    } else {
      setFormData({ route: "", travelDate: getTodayDate(), time: "" });
      setSelectedTrain(null);
    }
    setAvailableTrains([]);
  }, [editingItem, isOpen]);

  const handleSearch = () => {
    if (!formData.route || !formData.travelDate) {
      alert("Please enter route and travel date to search");
      return;
    }
    setSearching(true);
    setTimeout(() => {
      // Always show all dummy trains
      setAvailableTrains(dummyTrains);
      setSearching(false);
    }, 500);
  };

  const handleSelectTrain = (train) => {
    setSelectedTrain(train);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedTrain) {
      alert("Please select a train first");
      return;
    }
    const finalData = { ...formData, ...selectedTrain };
    onAdd(finalData);
    onClose();

    // Trigger auto-save event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("cartesUpdated"));
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6 rounded-t-[20px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-full bg-white p-2">
                <FaTrain className="h-6 w-6 text-purple-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Train Details' : 'Add Train Details'}</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {/* Search Form */}
          <div>
            <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Route</label>
            <input
              type="text"
              placeholder="e.g., Central → North Station"
              value={formData.route}
              onChange={(e) => setFormData({ ...formData, route: e.target.value })}
              className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Travel Date</label>
              <input
                type="date"
                value={formData.travelDate}
                onChange={(e) => setFormData({ ...formData, travelDate: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure & Arrival Time</label>
              <input
                type="text"
                placeholder="e.g., 8:00 AM - 12:30 PM"
                value={formData.time}
                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-purple-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
          </div>

          <button
            onClick={handleSearch}
            disabled={searching}
            className="w-full bg-purple-500 text-white py-3 rounded-xl font-semibold hover:bg-purple-600 transition-colors"
          >
            {searching ? "Searching..." : "Search Trains"}
          </button>

          {/* Train list */}
          {availableTrains.length > 0 && (
            <div className="mt-4 space-y-2 max-h-64 overflow-y-auto">
              {availableTrains.map(train => (
                <div
                  key={train.id}
                  onClick={() => handleSelectTrain(train)}
                  className={`p-3 border rounded-xl cursor-pointer flex justify-between items-center ${
                    selectedTrain?.id === train.id ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <div>
                    <p className="font-semibold">{train.name}</p>
                    <p className="text-sm text-gray-500">{train.route} - {train.time}</p>
                  </div>
                  <p className="font-semibold">${train.price}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 flex gap-4">
          <button
            onClick={handleSubmit}
            disabled={!selectedTrain}
            className="flex-1 bg-gradient-to-r from-purple-500 to-purple-600 text-white py-3 rounded-xl font-semibold hover:from-purple-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50"
          >
            {editingItem ? 'Update Train' : 'Add Train'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </Card>
    </div>
  );
};

export default RailwayModal;
  